<script setup lang="ts">
import { useCoursesStore } from '~~/stores/courses'

const route = useRoute()
const coursesStore = useCoursesStore()

const courseDetail = computed(() => coursesStore.state.courseDetail)

const title = computed(() => `${courseDetail.value?.data?.title} | kognisi.id`)
const keywords = computed(
  () =>
    `${courseDetail.value?.data?.title}, kursus ${courseDetail.value?.data?.title},kategori kursus, Agrifood Best Seller, inspirasi, Leadership, Human Resources, Self Development, kognisi, pengetahuan, edukasi, generasi muda`
)
const description = computed(() => {
  function extractText(html) {
    return html.replace(/<[^>]*>/g, '')
  }

  function truncateText(text, maxLength) {
    return text.length > maxLength ? text.slice(0, maxLength) + '...' : text
  }

  const text = extractText(courseDetail.value?.data?.description ?? '')
  return truncateText(text, 160)
})

const facilitatorDetail = computed(
  () => courseDetail.value?.data?.facilitatorDetails?.[0]
)

useSeoMeta({
  title: () => title.value,
  description: () => description.value,
  keywords: () => keywords.value,
  ogTitle: () => title.value,
  ogDescription: () => description.value,
  ogImage: () => courseDetail.value?.data?.thumbnailURL,
  ogImageAlt: () => title.value,
  ogImageUrl: () => courseDetail.value?.data?.thumbnailURL,
  ogUrl: () => `https://kognisi.id/kursus/${route.params.slug}`,
  ogType: 'website',
  twitterTitle: () => title.value,
  twitterDescription: () => description.value,
  twitterImage: () => courseDetail.value?.data?.thumbnailURL,
  twitterCard: 'summary'
})
useServerSeoMeta({
  robots: 'index, folow',
  title: () => title.value,
  description: () => description.value,
  keywords: () => keywords.value,
  ogTitle: () => title.value,
  ogDescription: () => description.value,
  ogImage: () => courseDetail.value?.data?.thumbnailURL,
  ogImageAlt: () => title.value,
  ogImageUrl: () => courseDetail.value?.data?.thumbnailURL,
  ogUrl: () => `https://kognisi.id/kursus/${route.params.slug}`,
  ogType: 'website',
  twitterTitle: () => title.value,
  twitterDescription: () => description.value,
  twitterImage: () => courseDetail.value?.data?.thumbnailURL,
  twitterCard: 'summary'
})

useJsonld(() => ({
  '@context': 'https://schema.org',
  '@type': 'Course',
  name: title.value,
  description: description.value,
  provider: {
    '@type': 'Organization',
    name: 'Kognisi',
    url: 'https://kognisi.id',
    logo: {
      '@type': 'ImageObject',
      url: 'https://kognisi.id/images/logo-kognisi-kompas.svg',
      width: {
        '@type': 'QuantitativeValue',
        value: 200
      },
      height: {
        '@type': 'QuantitativeValue',
        value: 50
      }
    },
    educationalCredentialAwarded: 'Sertifikat Penyelesaian',
    courseMode: 'Online',
    inLanguage: 'id',
    hasCourseInstance: {
      '@type': 'CourseInstance',
      name: title.value,
      description: courseDetail.value?.data?.description,
      url: `https://kognisi.id/kursus/${route.params.slug}`,
      location: {
        '@type': 'VirtualLocation',
        url: `https://kognisi.id/kursus/${route.params.slug}`
      },
      offers: {
        '@type': 'Offer',
        url: `https://kognisi.id/kursus/${route.params.slug}`,
        price:
          courseDetail.value?.data?.priceDiscount > 0
            ? courseDetail.value?.data?.priceDiscount
            : courseDetail.value?.data?.priceNormal || 0,
        priceCurrency: 'IDR',
        availability: 'https://schema.org/InStock'
      },
      instructor: {
        '@type': 'Person',
        name: facilitatorDetail?.value?.user?.fullName,
        description: facilitatorDetail?.value?.role,
        url: facilitatorDetail?.value?.imageURL
      }
    }
  }
}))

await useAsyncData('course-detail', () =>
  coursesStore.fetchCourseDetail({
    payload: {
      slugCourse: route.params?.slug
    },
    resolve: () => {
      coursesStore.fetchCourseDetailReview({
        payload: {
          courseSerial: courseDetail.value?.data?.serial,
          query: 'page=1&size=5'
        }
      })
    }
  })
)
</script>

<template>
  <Head>
    <link
      rel="canonical"
      :href="`https://kognisi.id/kursus/${route.params.slug}`"
    />
  </Head>
  <NuxtLayout name="kursus-detail">
    <NuxtLoadingIndicator />
  </NuxtLayout>
</template>
